import React, { useEffect, useState } from "react";
import "./adminHeader.css";
import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import { Link, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";
import { removeAuthToken } from "../../../../src/core/lib/localStorage";
import { AnimatePresence, motion } from "framer-motion";

import logo from "../../../assets/logo_header.webp";
import { FiMenu } from "react-icons/fi";
import { IoCloseCircleOutline } from "react-icons/io5";

const drawerWidth = 240;

const AdminHeader = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [adminSideBar, setAdminSideBar] = useState(false);
  const Navigaiton = useNavigate();
  const [userEmail, setUserEmail] = useState(localStorage.getItem("userEmail"));
  const [loginCheck, setLoginCheck] = useState(
    localStorage.getItem("loginCheck")
  );
  // console.log(loginCheck, "loginCheck");

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  useEffect(() => {
    setLoginCheck(localStorage.getItem("loginCheck"));
  }, [loginCheck]);

  const logout = () => {
    localStorage.setItem("userEmail", "");
    localStorage.setItem("loginCheck", false);
    localStorage.clear();
    Navigaiton("/login");
    removeAuthToken();
  };

  const drawer = (
    <div
      onClick={handleDrawerToggle}
      className="admindrawe_side_main"
      sx={{ textAlign: "center" }}
    >
      <Link to={"/"} className="logo_img_div">
        <img src={logo} alt="logo" />
      </Link>
      <ul className="admindrawer_menus">
        <li>
          <Link to={"/admin/dashboard"}>Dashboard</Link>
        </li>
        <li>
          <Link to={"/admin/userManagement"}>User Management</Link>
        </li>
        <li>
          <Link to={"/admin/tokenization"}>Tokenization</Link>
        </li>
        {/* <li>
              <Link to={"/admin/issuers"}>Issuers</Link>
            </li> */}
        <li>
          <Link to={"/admin/tokenmanagement"}>Token Management</Link>
        </li>
      </ul>
      {loginCheck && loginCheck == "true" ? (
        <button className="primary_btn drawer_adminheader_btn" onClick={logout}>
          Logout
        </button>
      ) : (
        ""
      )}
    </div>
  );

  return (
    <>
      <div sx={{ display: "flex" }} className="adminheader_wrp">
        {/* <CssBaseline /> */}
        <AppBar component="nav" className="adminheader_nav">
          <Toolbar className="nav_toolbar">
            <div className="adminnav_main">
              <div className="adminnav_menus_wrp">
                <Link to={"/"} className="logo_img_div">
                  <img src={logo} alt="logo" />
                </Link>

                <div className="admin_hedr_btn_wrp">
                  {loginCheck && loginCheck == "true" ? (
                    <button
                      className="primary_btn logout_admin"
                      onClick={logout}
                    >
                      Logout
                    </button>
                  ) : (
                    // (<button className="primary_btn signUp_admin header_btn">Sign Up</button>)
                    ""
                  )}
                </div>
              </div>

              {/* <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { lg: "none" } }}
              className="mobile_toggle"
            >
              <MenuIcon />
            </IconButton> */}

              <div className="mobile_toggle">
                <button
                  className="mobile_toggle_btn"
                  onClick={() => setAdminSideBar(true)}
                >
                  <FiMenu />
                </button>
              </div>
            </div>
          </Toolbar>
        </AppBar>

        <nav>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </div>

      {/* Mobile Drawer */}
      <AnimatePresence>
        {adminSideBar && (
          <>
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", bounce: 0, duration: 0.4 }}
              className="drawer_sidebar"
            >
              <div className="drawer_top">
                <Link to="/" className="mobile_logo_wrap">
                  <img src={logo} alt="Assetly logo" />
                </Link>
                <button
                  onClick={() => setAdminSideBar(false)}
                  className="drawer_close_btn"
                >
                  <IoCloseCircleOutline />
                </button>
              </div>

              <ul className="admindrawer_menus">
                <li>
                  <Link to={"/admin/dashboard"}>Dashboard</Link>
                </li>
                <li>
                  <Link to={"/admin/userManagement"}>User Management</Link>
                </li>
                <li>
                  <Link to={"/admin/tokenization"}>Tokenization</Link>
                </li>
                {/* <li>
              <Link to={"/admin/issuers"}>Issuers</Link>
            </li> */}
                <li>
                  <Link to={"/admin/tokenmanagement"}>Token Management</Link>
                </li>
              </ul>
              {loginCheck && loginCheck == "true" ? (
                <button
                  className="primary_btn drawer_adminheader_btn"
                  onClick={logout}
                >
                  Logout
                </button>
              ) : (
                ""
              )}
            </motion.div>

            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={() => setAdminSideBar(false)}
              className="drawer_overlay"
            />
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default AdminHeader;
